(() => {
  const SELECTOR = '[data-catalog-filter-drawer]';
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const priceFormatter = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 0 });

  const initializePriceRanges = (root) => {
    root.querySelectorAll('[data-price-range]').forEach((range) => {
      if (range.dataset.priceRangeInitialized === 'true') return;
      range.dataset.priceRangeInitialized = 'true';

      const minInput = range.querySelector('.v81-price-slider__input--min');
      const maxInput = range.querySelector('.v81-price-slider__input--max');
      const minField = range.querySelector('[data-price-min-field]');
      const maxField = range.querySelector('[data-price-max-field]');
      const minOutput = range.querySelector('[data-price-min-output]');
      const maxOutput = range.querySelector('[data-price-max-output]');
      const slider = range.querySelector('.v81-price-slider');
      const rangeMax = Number(range.dataset.rangeMax) || 0;

      if (!minInput || !maxInput || !minField || !maxField || !minOutput || !maxOutput || !slider || rangeMax <= 0) return;

      const update = (source) => {
        let minValue = Number(minInput.value);
        let maxValue = Number(maxInput.value);

        if (minValue > maxValue) {
          if (source === minInput) {
            maxValue = minValue;
            maxInput.value = String(maxValue);
          } else {
            minValue = maxValue;
            minInput.value = String(minValue);
          }
        }

        slider.style.setProperty('--price-min-position', `${(minValue / rangeMax) * 100}%`);
        slider.style.setProperty('--price-max-position', `${(maxValue / rangeMax) * 100}%`);
        minInput.style.zIndex = minValue > rangeMax * 0.75 ? '4' : '3';
        maxInput.style.zIndex = '3';
        minOutput.textContent = priceFormatter.format(minValue);
        maxOutput.textContent = priceFormatter.format(maxValue);
        minField.disabled = minValue <= 0;
        maxField.disabled = maxValue >= rangeMax;
        minField.value = minValue > 0 ? String(minValue) : '';
        maxField.value = maxValue < rangeMax ? String(maxValue) : '';
      };

      minInput.addEventListener('input', () => update(minInput));
      maxInput.addEventListener('input', () => update(maxInput));
      update();
    });
  };

  const initialize = (root) => {
    if (root.dataset.catalogFilterInitialized === 'true') return;
    root.dataset.catalogFilterInitialized = 'true';
    initializePriceRanges(root);

    const trigger = root.querySelector(':scope > summary');
    const drawer = root.querySelector('.v81-filter-drawer');
    const form = root.querySelector('.v81-filter-form');
    const closeButtons = root.querySelectorAll('[data-catalog-filter-close]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let closeTimer;

    const getFocusable = () => [...drawer.querySelectorAll(FOCUSABLE)].filter((element) => element.offsetParent !== null);

    const finishClose = (restoreFocus = true) => {
      window.clearTimeout(closeTimer);
      root.open = false;
      root.classList.remove('is-closing');
      document.body.classList.remove('v81-filter-drawer-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };

    const resetDrawerState = () => {
      window.clearTimeout(closeTimer);
      root.open = false;
      root.classList.remove('is-closing');
      document.body.classList.remove('v81-filter-drawer-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    const close = (restoreFocus = true) => {
      if (!root.open || root.classList.contains('is-closing')) return;
      root.classList.add('is-closing');
      document.body.classList.remove('v81-filter-drawer-open');
      closeTimer = window.setTimeout(() => finishClose(restoreFocus), reduceMotion.matches ? 0 : 240);
    };

    root.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(root.open));
      if (!root.open) {
        document.body.classList.remove('v81-filter-drawer-open');
        return;
      }
      root.classList.remove('is-closing');
      document.body.classList.add('v81-filter-drawer-open');
      window.requestAnimationFrame(() => drawer.querySelector('.v81-filter-drawer__close')?.focus({ preventScroll: true }));
    });

    closeButtons.forEach((button) => button.addEventListener('click', () => close(true)));

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const destination = new URL(form.action || window.location.pathname, window.location.origin);
      destination.search = new URLSearchParams(new FormData(form)).toString();
      resetDrawerState();
      window.location.assign(destination.toString());
    });

    window.addEventListener('pageshow', resetDrawerState);

    document.addEventListener('keydown', (event) => {
      if (!root.open || root.classList.contains('is-closing')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
